// extracted by mini-css-extract-plugin
module.exports = {"informativeCard":"car-pricing-card_informativeCard__T8GDM"};